import React from 'react';
import moment from 'moment';
import { Card, Col, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import WeatherCard from '../WeatherCard/WeatherCard';



function ForecastItem({ details }) {
    const popover = (
        <Popover id="popover-basic" className='w-50'>
            <Popover.Header as="h3">Climatic Details</Popover.Header>
            {/* <Popover.Header as="h3">{moment(details.dt_txt).format("DD/MM/YYYY, hh:mmA")}</Popover.Header> */}
            <Popover.Body style={{ minWidth: '200px' }}>
                <Card.Header className='text-center'><strong>{Math.ceil(details?.main?.temp - 273)} °C</strong></Card.Header>
                <hr />
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Wind:</Col>
                    <Col className='m-0 p-0'>{Math.ceil((details?.wind?.speed * 18) / 5)} KM/h</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Humidity:</Col>
                    <Col className='m-0 p-0'>{details?.main?.humidity} %</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Real Feel:</Col>
                    <Col className='m-0 p-0'>{Math.ceil(details?.main?.feels_like - 273)} °C</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Pressure:</Col>
                    <Col className='m-0 p-0'>{details?.main?.pressure} hPa</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Sea Level:</Col>
                    <Col className='m-0 p-0'>{details?.main?.sea_level} hPa</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Ground Feel:</Col>
                    <Col className='m-0 p-0'>{details?.main?.grnd_level} hPa</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Visibility:</Col>
                    <Col className='m-0 p-0'>{details?.main?.visibility} KM</Col>
                </div>

                <hr />
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Temp Max:</Col>
                    <Col className='m-0 p-0'>{Math.ceil(details?.main?.temp_max - 273)} °C</Col>
                </div>
                <div className='d-flex'>
                    <Col className='m-0 p-0'>Temp Min:</Col>
                    <Col className='m-0 p-0'>{Math.ceil(details?.main?.temp_min - 273)} °C</Col>
                </div>
            </Popover.Body>
        </Popover>
    );

    return (
        <Col style={{ cursor: 'pointer' }} sm={12} md={4} lg={3}>
            <OverlayTrigger trigger="click" placement='auto' overlay={popover} rootClose>
                <Card className="text-center w-100">
                    <Card.Header>{moment(details.dt_txt).format("DD/MM/YYYY, hh:mmA")}</Card.Header>
                    <Card.Body>
                        <Card.Title>
                            <img src={`https://openweathermap.org/img/wn/${details?.weather?.[0].icon}@2x.png`} width={100} height={100} />
                        </Card.Title>
                        <Card.Text title='' className='p-0 m-0 text-capitalize truncate'>
                            {details?.weather?.[0].main}
                        </Card.Text>
                        <Card.Text title={`${details?.weather?.[0].description}`} className='p-0 m-0 text-capitalize truncate'>
                            ({details?.weather?.[0].description})
                        </Card.Text>
                        <Card.Text className='p-0 m-0'>
                                Rain Chance: <strong className={`${details?.clouds?.all < 50 ? 'text-success' : 'text-danger'}`}>{details?.clouds?.all} %</strong>
                        </Card.Text>
                        {/* <Button variant="primary">Go somewhere</Button> */}
                    </Card.Body>
                    <Card.Footer className="text-muted">{Math.ceil(details?.main?.temp - 273)} °C</Card.Footer>
                </Card>
            </OverlayTrigger>
        </Col>
    );
}

export default ForecastItem;